const moment = require('moment-timezone');

angular
  .module('ordersSubscription')
  .component('ordersSubscription', {
    template: require('./orders-subscription.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function OrdersSubscriptionController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'subscription';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.targetEmployeeId = '-1';
        $resource(`${APIURL}/admin/employees?count=10000&include_unregister=false`).get((data) => {
          this.employees = data.users;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/setting`).get((data) => {
          this.serviceSetting = data;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });

        $scope.employeeChanged = () => {
          $scope.paging(1);
        };
        $scope.statusChanged = () => {
          $scope.paging(1);
        };

        $scope.paging = (page) => {
          $resource(`${APIURL}/admin/subscription/orders`).get({ page: page - 1, tbUserIdEmployee: this.targetEmployeeId, status: this.targetStatus }, (data) => {
            this.orders = data.orders;
            this.total_count = data.total_count;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.view = (tbSubscribeOrderId) => {
          $resource(`${APIURL}/admin/subscription/orders/${tbSubscribeOrderId}`).get({}, (data) => {
            this.viewOrder = data.order;
            console.log(data.order);
            jQuery('#modal-view').modal('show');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.cancelOrder = (targetOrder) => {
          if (confirm($translate.instant('세차를 취소 하시겠습니까?')) === false) {
            return;
          }
          $resource(`${APIURL}/admin/subscription/orders/:tbSubscribeOrderId/cancel`, { tbSubscribeOrderId: targetOrder.ID }).save(() => {
            alert($translate.instant('취소되었습니다.'));
            targetOrder.USEYN = 'N';
            jQuery('#modal-view').modal('show');
            this.orders = this.orders.map((order) => {
              if (order.ID === targetOrder.ID) {
                order.USEYN = 'N';
              }
              return order;
            });
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.startEdit = (targetOrder) => {
          targetOrder.editing = true;
          targetOrder.NEW_TB_USER_ID_EMPLOYEE = `${targetOrder.TB_USER_ID}`;
          $resource(`${APIURL}/admin/employees/available`).get((data) => {
            this.employees = data.employees;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
            targetOrder.editing = false;
          });
        };
        $scope.completeEdit = (targetOrder) => {
          $resource(`${APIURL}/admin/subscription/orders/${targetOrder.ID}/tbUserIdEmployee`).save({ TB_USER_ID_EMPLOYEE: targetOrder.NEW_TB_USER_ID_EMPLOYEE }, () => {
            const newEmployee = this.employees.filter(employee => employee.ID == targetOrder.NEW_TB_USER_ID_EMPLOYEE)[0]; // eslint-disable-line eqeqeq
            targetOrder.TB_USER_ID_EMPLOYEE = newEmployee.ID;
            targetOrder.EMPLOYEE_NAME = newEmployee.NAME;
            for (let idx = 0; idx < this.orders.length; idx += 1) {
              if (this.orders[idx].ID == targetOrder.ID) { // eslint-disable-line eqeqeq
                this.orders[idx].TB_USER_ID_EMPLOYEE = newEmployee.ID;
                this.orders[idx].EMPLOYEE_NAME = newEmployee.NAME;
              }
            }
            targetOrder.editing = false;
            alert($translate.instant('주문이 수정 되었습니다.'));
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };


        $scope.startEditDateTime = (targetOrder) => {
          alert('정기세차 날짜 변경은 다음 회차 부터 적용됩니다.\n현재 회차 다음에 진행될 세차날짜로 지정하여 변경 부탁드리며 현재 회차에 대한 변경은 개별 예약 변경으로 진행 부탁드립니다.');
          targetOrder.editingDateTime = true;
        };

        $scope.completeEditDateTime = (targetOrder) => {

          if (!targetOrder.NEW_DATE || targetOrder.NEW_DATE.length < 1) {
            alert($translate.instant('새로운 날짜를 입력해주세요.'));
            return;
          }

          if (!targetOrder.NEW_TIME || targetOrder.NEW_TIME.length < 1) {
            alert($translate.instant('새로운 시간을 입력해주세요.'));
            return;
          }

          $resource(`${APIURL}/admin/subscription/orders/${targetOrder.ID}/datetime`).save({ TB_USER_ID_EMPLOYEE: targetOrder.TB_USER_ID_EMPLOYEE, START_DATE: targetOrder.NEW_DATE, SERVICE_HOUR: targetOrder.NEW_TIME, TB_SUBSCRIPTION_PRODUCT_ID: targetOrder.TB_SUBSCRIBE_PRODUCT_ID, COMMENT: targetOrder.COMMENT_USER }, () => {
            alert($translate.instant('주문이 수정 되었습니다.'));
            jQuery('#modal-view').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        $scope.restore = (targetOrder) => {
          console.log(targetOrder);
          if (!targetOrder.NEW_ORDER_START_DATE) {
            alert($translate.instant('예약날짜를 선택해주세요.'));
            return;
          }
          if (!targetOrder.NEW_SERVICE_HOUR) {
            alert($translate.instant('예약시간을 선택해주세요.'));
            return;
          }
          if (!targetOrder.NEW_SERVICE_MINUTE) {
            alert($translate.instant('예약시간을 선택해주세요.'));
            return;
          }

          $resource(`${APIURL}/admin/orders/${targetOrder.ORDER_NO}/restore`).save({
            DATE: targetOrder.NEW_ORDER_START_DATE,
            HOUR: targetOrder.NEW_SERVICE_HOUR,
            MINUTE: targetOrder.NEW_SERVICE_MINUTE,
            TIMEZONE: moment.tz.guess(),
          }, (data) => {
            $scope.isLoading = false;
            console.log(data);
            alert($translate.instant('주문이 수정 되었습니다.'));
            jQuery('#modal-view').modal('hide');
          }, (err) => {
            $scope.isLoading = false;
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.total_count = 0;
        $scope.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-subscription/orders-subscription.component.js